'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HEADER_HEIGHT = exports.HEADER_HEIGHT = 68;
var THREADLIST_HEADER_HEIGHT = exports.THREADLIST_HEADER_HEIGHT = 182;
var THREADLIST_FOOTER_HEIGHT = exports.THREADLIST_FOOTER_HEIGHT = 40;

var OFFSET_HEIGHT = exports.OFFSET_HEIGHT = 64;
var OFFSET_HEIGHT_EXTENDED = exports.OFFSET_HEIGHT_EXTENDED = 76;

var MOBILE_OFFSET_HEIGHT = exports.MOBILE_OFFSET_HEIGHT = 104;
var MOBILE_OFFSET_HEIGHT_EXTENDED = exports.MOBILE_OFFSET_HEIGHT_EXTENDED = 116;

var BASE_WIDGET_HEIGHT = exports.BASE_WIDGET_HEIGHT = 530;
var SMALLEST_WIDGET_HEIGHT = exports.SMALLEST_WIDGET_HEIGHT = 247;

var BASE_WIDGET_WIDTH = exports.BASE_WIDGET_WIDTH = 396;

var CLOSE_BUTTON_AND_SPACING = exports.CLOSE_BUTTON_AND_SPACING = 16 + 60 + 16;
var SPACING_ABOVE_WIDGET = exports.SPACING_ABOVE_WIDGET = 24 + 20;